// https://docs.microsoft.com/en-us/dotnet/api/system.collections.queue?view=net-6.0
export class Queue extends Array {

    // METHODS
    //
    // GetEnumerator()
    // Returns an enumerator that iterates through the Queue.
    //
    // GetHashCode()
    // Serves as the default hash function.
    //
    // GetType()
    // Gets the Type of the current instance.
    //
    // MemberwiseClone()
    // Creates a shallow copy of the current Object.
    //
    // Synchronized(Queue)
    // Returns a new Queue that wraps the original queue, and is thread safe.
    //
    // ToString()
    // Returns a string that represents the current object.
    //
    // TrimToSize()
    // Sets the capacity to the actual number of elements in the Queue.

    // Removes all objects from the Queue.
    Clear() {
        this.splice(0);
    }

    // Creates a shallow copy of the Queue.
    Clone() {
        let res = new Queue();
        res.push(...this);
        return res;
    }

    // Determines whether an element is in the Queue.
    Contains(obj) {
        return this.includes(obj);
    }

    // Adds an object to the end of the Queue.
    Enqueue(...args) {
        return this.push(...args);
    }

    // Removes and returns the object at the beginning of the Queue.
    Dequeue() {
        return this.shift();
    }

    // Returns the object at the beginning of the Queue without removing it.
    Peek() {
        return this.length > 0 ? this[0] : undefined;
    }

    // Determines whether the specified object is equal to the current object.
    Equals(obj) {
        return this.Peek() === obj;
    }

    // Copies the Queue elements to a new array.
    ToArray() {
        return [...this];
    }

    // Copies the Queue elements to an existing one-dimensional Array, starting at the specified array index.
    CopyTo(arr, n = 0) {
        arr.splice(n, 0, ...this);
    }
}
